import script from "./CreateInvoiceWPOPrepayment.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateInvoiceWPOPrepayment.vue?vue&type=script&setup=true&lang=js"

import "./CreateInvoiceWPOPrepayment.vue?vue&type=style&index=0&id=471f3874&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-471f3874"]])

export default __exports__